import { render, staticRenderFns } from "./AgentskiiDogovor.vue?vue&type=template&id=b354cfb8&scoped=true&"
import script from "./AgentskiiDogovor.vue?vue&type=script&lang=js&"
export * from "./AgentskiiDogovor.vue?vue&type=script&lang=js&"
import style0 from "./AgentskiiDogovor.vue?vue&type=style&index=0&id=b354cfb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b354cfb8",
  null
  
)

component.options.__file = "AgentskiiDogovor.vue"
export default component.exports